module.exports = __webpack_public_path__ + "img/download-logopedist-files.8d2541b4.svg";